import React from "react";
import "./SectionTitle.css";

export default function SectionTitle({ subtitle, title }) {
  return (
    <div className={`section-title`}>
      {subtitle && <h3 className="section-subtitle">{subtitle}</h3>}
      {title && <h1 className="section-main">{title}</h1>}
    </div>
  );
}
